/* =========================================================
   MADSPEED7 — NEED HELP SYSTEM
   ========================================================= */

(function () {
  'use strict';

  let originalBodyOverflow = '';
  let productData = null;

  /* =========================================================
     POPUP SETUP
     ========================================================= */

  function setupNeedHelpPopup() {
    const helpButton = document.querySelector('.ms7-floating-help');
    const popup = document.querySelector('#ms7-help-popup');

    if (!helpButton || !popup) return;

    if (helpButton.dataset.ms7HelpSetup === 'true') return;

    const closeButtons = popup.querySelectorAll('[data-ms7-help-close]');

    /* ---------------------------------------------------------
       OPEN POPUP
       --------------------------------------------------------- */

    function openPopup() {
  originalBodyOverflow = document.body.style.overflow;

  popup.style.display = 'block';
  popup.setAttribute('aria-hidden', 'false');

  document.body.style.overflow = 'hidden';
}

    /* ---------------------------------------------------------
       CLOSE POPUP
       --------------------------------------------------------- */

    function closePopup() {

  popup.style.display = 'none';

  popup.setAttribute(
    'aria-hidden',
    'true'
  );

  document.body.style.overflow =
    originalBodyOverflow;

  /* Remove Shopify successful submission state */

  const url =
    new URL(window.location.href);

  if (
    url.searchParams.has('contact_posted')
  ) {

    url.searchParams.delete(
      'contact_posted'
    );

    window.history.replaceState(
      {},
      document.title,
      url.pathname +
      (url.search ? url.search : '') +
      (url.hash ? url.hash : '')
    );

  }

}

    /* ---------------------------------------------------------
       NEED HELP BUTTON
       --------------------------------------------------------- */

    helpButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      openPopup();
    });

    /* ---------------------------------------------------------
       CLOSE BUTTONS / OVERLAY
       --------------------------------------------------------- */

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();

        closePopup();
      });
    });

    /* ---------------------------------------------------------
       ESCAPE KEY
       --------------------------------------------------------- */

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        if (popup.getAttribute('aria-hidden') === 'false') {
          closePopup();
        }
      }
    });

       /* ---------------------------------------------------------
       INITIAL STATE / SUCCESS STATE
       --------------------------------------------------------- */

    const successMessage = popup.querySelector(
  '.ms7-help-form__success'
);

const contactPosted =
  new URLSearchParams(
    window.location.search
  ).get('contact_posted') === 'true';

if (
  successMessage &&
  contactPosted
) {

      const form = popup.querySelector('.ms7-help-form');
      const intro = popup.querySelector('.ms7-help-popup__intro');
      const whatsapp = popup.querySelector('.ms7-help-popup__whatsapp');
      const title = popup.querySelector('#ms7-help-title');

      if (form) {
        form.querySelectorAll(
          '.ms7-help-form__field, .ms7-help-form__submit'
        ).forEach(function (element) {
          element.style.display = 'none';
        });
      }

      if (intro) {
        intro.style.display = 'none';
      }

      if (whatsapp) {
        whatsapp.style.display = 'none';
      }

      if (title) {
        title.textContent = 'YOUR MESSAGE HAS BEEN SENT';
      }

      successMessage.textContent =
        "Thank you, we've received your message and will get back to you within 24 hours.";

      popup.style.display = 'block';
      popup.setAttribute('aria-hidden', 'false');

      originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

    } else {

      popup.style.display = 'none';

      popup.setAttribute(
        'aria-hidden',
        'true'
      );

    }

    helpButton.dataset.ms7HelpSetup = 'true';

    }

  /* =========================================================
     PRODUCT CONTEXT
     ========================================================= */

  function getProductUrlField() {
    return document.querySelector('#MS7HelpForm-product-url');
  }

  function getSkuField() {
    return document.querySelector('#MS7HelpForm-sku');
  }


  /* =========================================================
     PRODUCT URL
     ========================================================= */

  function updateProductUrl() {
    const field = getProductUrlField();

    if (!field) return;

    field.value = window.location.href;
  }


  /* =========================================================
     CURRENT VARIANT ID
     ========================================================= */

  function getCurrentVariantId() {
    const variantInput = document.querySelector(
      'form[action*="/cart/add"] input[name="id"]'
    );

    if (variantInput && variantInput.value) {
      return String(variantInput.value);
    }

    const urlParams = new URLSearchParams(window.location.search);
    const variantFromUrl = urlParams.get('variant');

    if (variantFromUrl) {
      return String(variantFromUrl);
    }

    return '';
  }


  /* =========================================================
     LOAD PRODUCT JSON
     ========================================================= */

  async function loadProductData() {
    if (!document.body.classList.contains('template-product')) {
      return;
    }

    const productHandle = window.location.pathname
      .replace(/^\/+|\/+$/g, '')
      .split('/products/')[1];

    if (!productHandle) return;

    try {
      const response = await fetch(
        window.Shopify.routes.root +
        'products/' +
        productHandle +
        '.js',
        {
          cache: 'no-store'
        }
      );

      if (!response.ok) return;

      productData = await response.json();

      updateSku();
    } catch (error) {
      console.log(
        'MADSPEED7 Need Help product data error:',
        error
      );
    }
  }


  /* =========================================================
     UPDATE SKU
     ========================================================= */

  function updateSku() {
    const field = getSkuField();

    if (!field) return;

    if (!productData || !productData.variants) {
      field.value = '';
      return;
    }

    const variantId = getCurrentVariantId();

    if (!variantId) {
      field.value = '';
      return;
    }

    const variant = productData.variants.find(function (item) {
      return String(item.id) === String(variantId);
    });

    if (variant) {
      field.value = variant.sku || '';
    } else {
      field.value = '';
    }
  }


  /* =========================================================
     WATCH VARIANT CHANGES
     ========================================================= */

  function setupVariantTracking() {
    if (
      !document.body.classList.contains('template-product')
    ) {
      return;
    }

    document.addEventListener(
      'change',
      function (event) {
        if (
          event.target.matches(
            'select[name^="options"], input[name^="options"], input[name="id"]'
          )
        ) {
          setTimeout(updateSku, 50);
        }
      }
    );

    /* ---------------------------------------------------------
       Dawn / Shopify variant events
       --------------------------------------------------------- */

    document.addEventListener(
      'variant:change',
      function () {
        setTimeout(updateSku, 50);
      }
    );

    document.addEventListener(
      'variantChange',
      function () {
        setTimeout(updateSku, 50);
      }
    );
  }

  function setupWhatsAppButton() {
  const whatsappButton = document.querySelector('.ms7-help-popup__whatsapp');

  if (!whatsappButton) return;
  if (whatsappButton.dataset.ms7WhatsAppSetup === 'true') return;

  whatsappButton.addEventListener('click', function (event) {
    event.preventDefault();

    const phoneNumber = '447377876353';
    const message =
      'Hello, I am currently on your site, www.madspeed7.co.uk, and I would like some help, please.';

    const whatsappUrl =
      'https://wa.me/' +
      phoneNumber +
      '?text=' +
      encodeURIComponent(message);

    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');

  });

  whatsappButton.dataset.ms7WhatsAppSetup = 'true';
}

  /* =========================================================
     INITIALISE
     ========================================================= */

  function initMadspeed7NeedHelp() {
  setupNeedHelpPopup();
  setupWhatsAppButton();
  updateProductUrl();
  setupVariantTracking();
  loadProductData();
}


    /* =========================================================
     PAGE LOAD
     ========================================================= */

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initMadspeed7NeedHelp
    );
  } else {
    initMadspeed7NeedHelp();
  }


  /* =========================================================
   RESET NEED HELP AFTER BACK / FORWARD
   ========================================================= */

window.addEventListener('pageshow', function (event) {

  const navigationEntries =
    performance.getEntriesByType('navigation');

  const navigationType =
    navigationEntries.length
      ? navigationEntries[0].type
      : '';

  const isBackForwardNavigation =
    navigationType === 'back_forward';

  if (
    !event.persisted &&
    !isBackForwardNavigation
  ) {
    return;
  }

  const popup =
    document.querySelector('#ms7-help-popup');

  if (!popup) return;

  popup.style.display = 'none';

  popup.setAttribute(
    'aria-hidden',
    'true'
  );

  document.body.style.overflow = '';

});

})();